const MIN_WIDTH_PX = 992;
const EXIT_DISTANCE = 60;
const SCALE_AMOUNT = 0.04;
const STICKY_OFFSET_BELOW_HEADER = 80;
const MAX_BLUR = 10;
const LERP_SPEED = 0.2;
const SNAP_THRESHOLD = 0.001;

function lerp( a, b, t ) {
  return a + ( b - a ) * t;
}

function getSectionContext() {
  const section = document.querySelector(
    '.e-stn--onscroll-stacked-content-cards-with-media'
  );
  const wrapper = section?.querySelector( '.swiper-wrapper' );
  const slides = section ? Array.from( section.querySelectorAll( '.swiper-slide' ) ) : [];
  const valid = section && wrapper && slides.length > 0;
  return valid ? { section, wrapper, slides } : null;
}

function isMinWidth992() {
  const viewportWidth = window.visualViewport?.width
    || document.documentElement.clientWidth
    || window.innerWidth;
  return viewportWidth >= MIN_WIDTH_PX;
}

function clearSlideStyles( slides ) {
  slides.forEach( ( slide ) => {
    slide.style.top = '';
    slide.style.transform = '';
    slide.style.opacity = '';
    slide.style.filter = '';
  } );
}

function getStickyTop() {
  const header =
    document.querySelector( 'header' ) ||
    document.querySelector( '.e-div--header-wrapper' )?.closest( 'header' );
  const headerHeight = header ? header.offsetHeight : 0;
  return headerHeight + STICKY_OFFSET_BELOW_HEADER;
}

function getSlideTops( wrap, slideEls ) {
  const style = window.getComputedStyle( wrap );
  const paddingTop = parseFloat( style.paddingTop ) || 0;
  const gap = parseFloat( style.gap ) || 0;
  const tops = [];
  let top = paddingTop;
  for ( const slide of slideEls ) {
    tops.push( top );
    top += slide.offsetHeight + gap;
  }
  return tops;
}

function getTargetProgress( slide, index, slideTops, scrollY, wrapperDocTop, stickyTop, slides ) {
  const slideTop = slideTops[index];
  const scrollStick = wrapperDocTop + slideTop - stickyTop;
  const nextSlide = slides[index + 1];
  const scrollEnd = nextSlide
    ? wrapperDocTop + slideTops[index + 1] - stickyTop
    : scrollStick + slide.offsetHeight;

  const scrollRange = Math.max( scrollEnd - scrollStick, 1 );
  let progress = ( scrollY - scrollStick ) / scrollRange;
  return Math.min( Math.max( progress, 0 ), 1 );
}

function applyProgress( slide, progress ) {
  const eased = progress * progress * ( 3 - 2 * progress );
  const translateY = eased * -EXIT_DISTANCE;
  const scale = 1 - eased * SCALE_AMOUNT;
  const opacity = 1 - eased;
  const blur = eased * MAX_BLUR;

  slide.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;
  slide.style.opacity = Math.round( opacity * 100 ) / 100;
  slide.style.filter = blur > 0.1 ? `blur(${blur.toFixed( 1 )}px)` : '';
}

function resetSlideTransform( slide ) {
  slide.style.transform = '';
  slide.style.opacity = '';
  slide.style.filter = '';
}

function updateSlideProgress( slide, index, env ) {
  const { slides, slideTops, scrollY, wrapperDocTop, stickyTop, state } = env;

  if ( index === slides.length - 1 ) {
    resetSlideTransform( slide );
    return false;
  }

  const target = getTargetProgress(
    slide, index, slideTops, scrollY, wrapperDocTop, stickyTop, slides
  );

  state.current = lerp( state.current, target, LERP_SPEED );
  const snapped = Math.abs( state.current - target ) < SNAP_THRESHOLD;
  if ( snapped ) {
    state.current = target;
  }

  applyProgress( slide, state.current );
  return !snapped;
}

function processSlides( slides, slideTops, states, stickyTop ) {
  const scrollY = window.scrollY;
  const wrapperDocTop = slides[0].parentElement.getBoundingClientRect().top + scrollY;
  let settling = false;

  slides.forEach( ( slide, index ) => {
    slide.style.top = `${stickyTop}px`;
    const stillSettling = updateSlideProgress( slide, index, {
      slides, slideTops, scrollY, wrapperDocTop, stickyTop, state: states[index],
    } );
    if ( stillSettling ) settling = true;
  } );

  return settling;
}

function initOnscrollStackedContentCards() {
  const ctx = getSectionContext();
  if ( !ctx ) return;

  const { wrapper, slides } = ctx;
  const slideTopsRef = { current: getSlideTops( wrapper, slides ) };
  const states = slides.map( () => ( { current: 0 } ) );
  const rafRef = { current: null };

  function tick() {
    rafRef.current = null;

    if ( !isMinWidth992() ) {
      clearSlideStyles( slides );
      return;
    }

    const settling = processSlides( slides, slideTopsRef.current, states, getStickyTop() );
    if ( settling ) {
      rafRef.current = requestAnimationFrame( tick );
    }
  }

  function scheduleUpdate() {
    if ( rafRef.current == null ) {
      rafRef.current = requestAnimationFrame( tick );
    }
  }

  window.addEventListener( 'scroll', scheduleUpdate, { passive: true } );
  window.addEventListener( 'resize', () => {
    if ( isMinWidth992() ) {
      slideTopsRef.current = getSlideTops( wrapper, slides );
    }
    scheduleUpdate();
  } );

  tick();
}

( function () {
  if ( !isMinWidth992() ) return;
  initOnscrollStackedContentCards();
} )();
